
import { i18nText } from '@/locales';
import Vue from "vue";
import Component from "vue-class-component";
import { ITableColumn } from "@/entity/table/table.types";
import { LoyaltyCertFormData } from "@/form/loyalty/loyaltyCert/LoyaltyCert";
import { loyaltySubscriptionForm } from "@/form/loyalty/loyaltySubscription/loyaltySubscription";
import { ServiceFormData } from "@/form/serviceCreate/Service";
import { VisitPayFormData } from "@/form/visits/Pay/Visit";
import { IClientsListItem } from "@/entity/clients/clients.types";
import { ILoyaltyCertTypeListItem } from "@/entity/loyalty/loyaltyCert/loyaltyCertType/LoyaltyCertType.types";
import { IServicesListItem } from "@/entity/services/services.types";
import { DataEntity } from "@/entity/warehouse/Products/Products.types";
import { ProductsStockStore } from "@/store/modules/Warehouse/ProductsStock";
import { ServiceStore } from "@/store/modules/Services";
import { LoyaltySubscriptionTypeStore } from "@/store/modules/Loyalty/Subscription/LoyaltySubscriptionType";
import { LoyaltyCertStore } from "@/store/modules/Loyalty/Cert/LoyaltyCert";
import { CashBoxMix } from "@/UI/mixins/CashBoxMix";
import { mixins } from "vue-class-component";
import { AppFormsStore } from "@/store/modules/appForms";

@Component
export class StatusMix extends mixins(CashBoxMix) {
    autoExpandParent = true;
    modalWindowServices = false;
    modalWindowProducts = false;
    showPayModal = false;
    confirmLoading = false;

    formCerificate = new LoyaltyCertFormData();
    formSubsscription = new loyaltySubscriptionForm();
    service = new ServiceFormData();
    visitPayForm = new VisitPayFormData();

    modalWindowCertificate = false;
    modalWindowsSubscription = false;

    visibleCashCashboxes = false;
    visibleCardCashboxes = false;

    treeProducts: Array<any> = [];
    treeServices: Array<any> = [];
    expandedRowKeys: Array<any> = [];

    expandedKeysServices: any = [];
    checkedKeysServices: any = [];
    selectedKeysServices = [];
    expandedKeysProduct: any = [];
    checkedKeysProduct: any = [];
    selectedKeysProduct = [];

    dataClients: Array<IClientsListItem> = [];
    dataloyaltyCertsTypes: Array<ILoyaltyCertTypeListItem> = [];
    dataService: Array<IServicesListItem> = [];
    dataProducts: Array<DataEntity> = [];
    productsList: Array<Record<any, any>> = [];

    boxDataCertificate: any[] = [];
    boxDataSubscription: any[] = [];

    //boxData: any[] = [];

    dataSubscriptionTypes: any = [];
    total_price: number = 0;
    saveBasketKey = 1;
    StudioId = Vue.router.currentRoute.params["id"];

    get total(): string {
        let total_price = 0;
        for (let i = 0; i < this.boxData.length; i++) {
            //total_price += Number(this.boxData[i].total * this.boxData[i].created)
            total_price += Number(this.boxData[i].total);
        }
        const format = function (price: any, n: number, x: number, s: string, c: string) {
            const re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
                num = price.toFixed(Math.max(0, ~~n));
            return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","));
        };
        return format(total_price, 2, 3, " ", ".");
    }

    get boxData(): any {
        return AppFormsStore.boxData;
    }

    calculator(record: Record<any, any>): void {
console.warn(record)
        this.total_price = 0;

        for (let i = 0; i < this.boxData.length; i++) {
            if (this.boxData[i].key == record.key) {
                if (record.discount > 100) {
                    record.discount = 100;
                } else if (record.discount < 0) {
                    record.discount = 0;
                } else if (isNaN(record.discount)) {
                    record.discount = 0;
                }

                if (!record.discount) {
                    record.discount = this.boxData[i].discount;
                }
                if (!record.created) {
                    record.created = this.boxData[i].created;
                }
                if (!record.balance) {
                    record.balance = this.boxData[i].balance;
                }

                this.boxData[i].total = record.balance * record.created - (record.discount * record.balance) / 100;
            }

            if (!record.key) {
                this.boxData[i].total =
                    this.boxData[i].balance * this.boxData[i].created -
                    (this.boxData[i].discount * this.boxData[i].balance) / 100;
            }

            this.total_price += this.boxData[i].total;
        }

        const format = function (price: any, n: number, x: number, s: string, c: string) {
            const re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
                num = price.toFixed(Math.max(0, ~~n));

            return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","));
        };

        this.total_price = format(this.total_price, 2, 3, " ", ".");
    }

    async pushToBox(data: Record<any, any>): Promise<void> {
        this.boxData.push(data);
        this.calculator({});
    }

    get cash_cashboxes(): any {
        if (this.cashBoxes && this.cashBoxes.data) {
            return this.cashBoxes.data.filter((e) => e && e.type && e.type.id == 1);
        } else {
            return [];
        }
    }

    get card_cashboxes(): any {
        if (this.cashBoxes && this.cashBoxes.data) {
            return this.cashBoxes.data.filter((e: any) => e && e.type && e.type.id == 2);
        } else {
            return [];
        }
    }

    get products(): any {
        return ProductsStockStore.items;
    }

    get serviceData(): any {
        return ServiceStore.services;
    }
    get services(): any {
        return ServiceStore.service;
    }

    get subscriptionsTypes(): any {
        return LoyaltySubscriptionTypeStore.loyaltySubscriptionTypes;
    }

    get certificates(): any {
        return LoyaltyCertStore.loyaltyCerts;
    }

    get columns(): ITableColumn[] {
        return [
            {
                title: i18nText("Позиция"),
                dataIndex: "",
                key: "name",
                width: "40%",
                scopedSlots: {
                    customRender: "name",
                },
            },
            {
                title: i18nText("Кол-во"),
                dataIndex: "created",
                key: "created",
                scopedSlots: {
                    customRender: "created",
                },
            },
            {
                title: i18nText("Цена, ₽"),
                dataIndex: "balance",
                key: "balance",
                scopedSlots: {
                    customRender: "balance",
                },
            },
            {
                title: i18nText("Скидка, %"),
                dataIndex: "discount",
                key: "discount",
                scopedSlots: {
                    customRender: "discount",
                },
            },
            {
                title: i18nText("Итог, ₽"),
                dataIndex: "total",
                key: "total",
                scopedSlots: {
                    customRender: "total",
                },
            },
            {
                title: "",
                dataIndex: "delete",
                key: "delete",
                scopedSlots: {
                    customRender: "delete",
                },
            },
        ];
    }
}
